import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import WordSearchGrid from '../components/WordSearchGrid';
import './Round.css';

const WORDS = ['LADOO', 'CHAKALIS', 'KARANJIS', 'SAMOSA', 'PINNI'];
const GRID_SIZE = 10;

export default function WordPuzzle() {
  const navigate = useNavigate();
  const [revealed, setRevealed] = useState(false);

  return (
    <Layout round="Round 2" title="Identify festive delicacies" subtitle="(Words can be in any direction.)">
      <WordSearchGrid words={WORDS} gridsize={GRID_SIZE} />

      {revealed && (
        <div className="clue-row">
          {WORDS.map((w, idx) => (
            <p key={idx} className="clue-answer revealed">
              {w}
            </p>
          ))}
        </div>
      )}

      {!revealed ? (
        <button className="hunt-btn" onClick={() => setRevealed(true)}>
          Reveal Answer
        </button>
      ) : (
        <button className="hunt-btn" onClick={() => navigate('/round-3')}>
          Next
        </button>
      )}
    </Layout>
  );
}
